import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Project } from '@leverege/api-redux'
import { List, Toast } from '@leverege/ui-elements'
import ModelUtil from '@leverege/model-util'

const { changeObject } = ModelUtil

export default function useClientIds( opts ) {
  const project = useSelector( state => state.project )
  
  const clientIdsApi = useMemo( () => {
    return Project( project.id ).clientIds()
  }, [ project ] )

  const clientIds = useSelector( state => clientIdsApi.getClientIds( state ) )

  const [ showAdd, setShowAdd ] = useState( false )

  const onCreateClientId = useCallback( () => {
    setShowAdd( true )
  }, [] )

  const onClose = useCallback( () => {
    setShowAdd( false )
  }, [] )

  const dispatch = useDispatch()
  
  const onEvent = useCallback( ( { data, value } ) => {
    switch ( data ) {
      case 'delete':
        dispatch( clientIdsApi.item( value.id ).delete() )
        break;
      default:
    }
  }, [ clientIdsApi ] )

  useEffect( () => {
    dispatch( clientIdsApi.list() )
  }, [] )

  const [ selection, setSelection ] = useState()

  const fauxComponent = useMemo( () => {
    return {
      state : {
        selection
      },
      setState( change ) {
        const { selection } = change
        setSelection( selection )
      }
    }
  }, [ selection ] )

  const selector = useRef( new List.SingleSelector( fauxComponent, 'selection', { idKey : 'id' } ) )

  const selectedItem = useMemo( () => {
    if ( selection ) {
      return clientIds.find( clientId => clientId.id === selection )
    }

    return null
  }, [ selection, clientIds ] )

  const onDelete = useCallback( ( clientId ) => {
    dispatch( Project( project.id ).clientId( clientId.id ).delete() )
  }, [ project, dispatch ] )

  const onSave = useCallback( ( { value, oldValue } ) => {
    const opts = {
      undefinedIsNull : true,
      keys : [
        'alias',
        'authorizationUri'
      ]
    }

    const change = changeObject( value, oldValue, opts )

    if ( Object.keys( change ).length > 0 ) {
      dispatch( Project( project.id ).clientId( value.id ).update( change ) )
        .then( () => {
          Toast.success( `Client ID ${value.clientId} Updated Successfully`, {} )
        } )
        .catch( ( err ) => {
          Toast.error( err.message, {} )
        } )
    }
  }, [ project, dispatch ] )

  const onAddClient = useCallback( ( data ) => {
    onClose()

    dispatch( Project( project.id ).clientIds().create( data ) )
      .then( ( data ) => {
        Toast.success( `Client ID ${data.clientId} Created Successfully`, {} )
      } )
      .catch( ( err ) => {
        Toast.error( [ 'Client ID Creation Failed', err.message ] )
      } )
  }, [ onClose, project, dispatch ] )

  return {
    clientIds,
    clientIdsApi,
    onAddClient,
    onClose,
    onCreateClientId,
    onDelete,
    onEvent,
    onSave,
    selectedItem,
    selection,
    selector : selector.current,
    showAdd,
  }
}
